/**
 * @author        matthew@zumper.com (Matthew Talamini)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   STR List Item Card (outermost card element, handles height & shape of cards)
 */

// This component is being used in multiple places!

/** @jsx jsx */
import { jsx } from '@emotion/react'
import { type MouseEvent, type ReactNode, type Ref, forwardRef } from 'react'
import * as styles from './styles'

export interface STRListItemCardProps {
  children: ReactNode | ReactNode[]
  isLongTerm: boolean
  isShowingNewListingCard?: boolean
  onClick?: (e: MouseEvent<HTMLElement>) => void
  onMouseEnter?: (e: MouseEvent<HTMLElement>) => void
  onMouseLeave?: (e: MouseEvent<HTMLElement>) => void
}

export const STRListItemCard = forwardRef(
  (
    {
      children,
      isLongTerm,
      isShowingNewListingCard,
      onClick,
      onMouseEnter,
      onMouseLeave,
    }: STRListItemCardProps,
    ref: Ref<HTMLDivElement>
  ) => {
    return (
      <div
        css={[
          styles.container,
          isLongTerm ? styles.longTermGridContainer : styles.gridContainer,
          isShowingNewListingCard && styles.newListingCardPlaceholder,
        ]}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        ref={ref}
      >
        {children}
      </div>
    )
  }
)
